/**
 * Political Control Over Time.
 *
 * Renders S&P 500 average annual returns by administration as a stack of
 * tinted rows, one per period, each carrying a party pill.
 *
 * The data is static and small, so it is inlined here rather than fetched —
 * a network round trip for five rows would only delay the paint.
 */
(function () {
	"use strict";

	var PERIODS = [
		{ years: "2000–2008", party: "Republican", president: "G.W. Bush", spReturn: "-2.7%" },
		{ years: "2008–2016", party: "Democrat", president: "Obama", spReturn: "+13.8%" },
		{ years: "2016–2020", party: "Republican", president: "Trump", spReturn: "+11.8%" },
		{ years: "2020–2024", party: "Democrat", president: "Biden", spReturn: "+8.2%" },
		{ years: "2025–2029", party: "Republican", president: "Trump", spReturn: "TBD" }
	];

	/**
	 * Which colour the return value takes: green up, red down, neutral for a
	 * term that has not finished yet.
	 */
	function toneOf(value) {
		if (value === "TBD") return "tbd";
		return value.charAt(0) === "-" ? "neg" : "pos";
	}

	function buildPeriod(period) {
		var party = period.party.toLowerCase();

		var row = document.createElement("div");
		row.className = "political-period political-period--" + party;

		var head = document.createElement("div");
		head.className = "political-period__head";

		var years = document.createElement("span");
		years.className = "political-period__years";
		years.textContent = period.years;

		var pill = document.createElement("span");
		pill.className = "political-period__party";
		pill.textContent = period.party.toUpperCase();

		head.appendChild(years);
		head.appendChild(pill);

		var ret = document.createElement("div");
		ret.className = "political-period__return";

		var label = document.createElement("span");
		label.textContent = "Avg S&P return:";

		var value = document.createElement("span");
		value.className =
			"political-period__value political-period__value--" + toneOf(period.spReturn);
		value.textContent = period.spReturn;

		ret.appendChild(label);
		ret.appendChild(value);

		row.appendChild(head);
		row.appendChild(ret);

		// The president's name is useful context but must not compete with the
		// figures, so it rides as a tooltip rather than a fourth line.
		row.title = period.president;

		return row;
	}

	function render(widget) {
		var timeline = widget.querySelector(".political-timeline");

		// Already rendered — guards against a double init if the script is
		// enqueued twice by a caching plugin.
		if (!timeline || timeline.children.length) return;

		var frag = document.createDocumentFragment();

		PERIODS.forEach(function (period) {
			frag.appendChild(buildPeriod(period));
		});

		timeline.appendChild(frag);
	}

	function init() {
		var widgets = document.querySelectorAll(".political-control-widget");

		Array.prototype.forEach.call(widgets, render);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
